import { RequestTypes } from 'legacy/lut/classes/models/onboarding/Onboarding'

export const checkIsProgramElementAllowed = (requestType: RequestTypes) =>
  [RequestTypes.Onboarding, RequestTypes.RetailOnboarding].includes(requestType)
